export enum UserRole {
    guest = 'guest',
    salesRep = 'salesRep',
    user = 'user',
    admin = 'admin',
    // An admin who may also change how the tenant behaves (settings, catalogues, integrations)
    // and hand out this role. The first one per tenant is set in the database, never in code.
    superAdmin = 'superAdmin',
}

export interface IUserRolesEntity {
    roles: UserRole[];
}
